import * as React from 'react';

import './content-background.scss';

interface IProps {
  game: string;
}

export const ContentBackground: React.FC<IProps> = (props) => {
  return <div className={`content-background ${props.game}`}></div>;
};
